module.exports = __webpack_public_path__ + "static/media/Adventure.96fbb390.png";